export const getSpineMm = (
  spreads: number,
  paperType: "matte" | "lustre"
) => {
  const SPINE_BASE_10 = {
    matte: 22,
    lustre: 25,
  };

  const SPINE_INCREMENT = {
    matte: 1.0,
    lustre: 1.5,
  };

  return (
    SPINE_BASE_10[paperType] +
    Math.max(0, spreads - 10) * SPINE_INCREMENT[paperType]
  );
};

export const getCoverWidthMm = ({
  spreads,
  paperType,
  cartonWmm,
  foldMm = 30,
  gapMm = 18,
}: {
  spreads: number;
  paperType: "matte" | "lustre";
  cartonWmm: number;
  foldMm?: number;
  gapMm?: number;
}) => {
  const spineMm = getSpineMm(spreads, paperType);

  return (
    foldMm +
    cartonWmm +
    gapMm +
    spineMm +
    gapMm +
    cartonWmm +
    foldMm
  );
};

export const getCoverHeightMm = (
  cartonHmm: number,
  foldMm = 30
) => cartonHmm + 2 * foldMm;